import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { LayoutDualColComponent } from './layout-dual-col.component';
import { LetDirective } from '@ngrx/component';
import { DrawerModule } from '../drawer';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatIconModule } from '@angular/material/icon';
import { AvatarModule } from '../avatar';
import {
  LayoutDualColAsideDirective,
  LayoutDualColDrawerContentDirective,
} from './layout-dual-col-sections';

@NgModule({
  declarations: [
    LayoutDualColComponent,
    LayoutDualColAsideDirective,
    LayoutDualColDrawerContentDirective,
  ],
  imports: [
    CommonModule,
    LetDirective,
    DrawerModule,
    MatButtonToggleModule,
    MatIconModule,
    AvatarModule,
  ],
  exports: [
    LayoutDualColComponent,
    LayoutDualColAsideDirective,
    LayoutDualColDrawerContentDirective,
  ],
})
export class LayoutDualColModule {}
